import type { JSX } from 'react';

import { SpriteIcon } from '../sprite-icon';
import type { SVGProps } from '../types';

export const InfoIcon = (props: SVGProps): JSX.Element => {
  // 48px intrinsic size, not SpriteIcon's 24px default. Consumer w-*/h-*/size-* classes still win.
  return (
    <SpriteIcon spriteId="info-circle" width="48" height="48" {...props} />
  );
};
